import { Injectable, signal } from '@angular/core';

/** The launchpad's module filter. The box lives in the shell's header; the launchpad reads it (ZEY-2419). */
@Injectable({ providedIn: 'root' })
export class LaunchpadSearchService {
  readonly query = signal('');
}
